/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectActualLpis } from './subjectActualLpis.model';


export interface ParLpisEntity { 
    acreage?: number;
    acreageG?: number;
    id: number;
    idFb?: number;
    idUz?: number;
    isLpisConcerned?: boolean;
    korekce?: number;
    kulturaId?: number;
    parId: number;
    parcelAcreage?: number;
    parcelAcreageG?: number;
    subjectActualLpis?: SubjectActualLpis;
}

